<div class="auth-layout">
	<app-header
		homeLink="login"
		data-qa="page-header"
	></app-header>
	<div
		class="content-wrap"
		role="main"
		data-qa="auth-layout-content"
	>
		<router-outlet></router-outlet>
	</div>
	<app-footer data-qa="page-footer"></app-footer>
</div>
